export default __webpack_public_path__ + "static/media/mn.e271c935.svg";